// import React, { useEffect, useState } from "react";
// import { Box, Button, Grid, IconButton, TextField } from "@mui/material";

// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router";
// import Admin from "../Dashboard";
// import DeleteSchoolModal from "../School/DeleteSchoolModal";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

// const rows = [
//   { id: 1, title: "Title 1", description: "Description 1" },
//   { id: 2, title: "Title 2", description: "Description 2" },
//   { id: 3, title: "Title 3", description: "Description 3" },
//   // Add more rows as needed
// ];

// const HigherOfficial = () => {
//   const navigate = useNavigate();
//   const [higherOfficialData, setHigherOfficialData] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [deleteSchool, setDeleteSchool] = useState("");
//   const [deleteSchoolId, setDeleteSchoolId] = useState("");
//   const getHeaderOfficialDetails = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}/getHeaderDetails`
//       );
//       if (response.status == 200) {
//         setHigherOfficialData(response.data);
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     getHeaderOfficialDetails();
//   }, []);
//   const handleDelete = async (id) => {
//     try {
//       const response = await axios.delete(
//         `${process.env.REACT_APP_BASE_URL}/deleteHeaderOfficialById/${id}`,
//         {
//           headers: {
//             Authorization: localStorage.getItem("admin_token"),
//           },
//         }
//       );
//       if (response.status == 200) {
//         getHeaderOfficialDetails();
//       }
//     } catch (error) {
//       if (error.response.status == 403) {
//         localStorage.clear();
//         navigate("/admin/login");
//       }
//     }
//   };
//   const handleDeleteSchool = (school, schoolId) => {
//     setDeleteSchool(school);
//     setDeleteSchoolId(schoolId);
//     setOpen(true);
//   };

// const handleDragEnd = async (result) => {
//     if (!result.destination) return;

//     const updated = Array.from(items);
//     const [movedItem] = updated.splice(result.source.index, 1);
//     updated.splice(result.destination.index, 0, movedItem);

//     // Recalculate all order numbers
//     const reordered = updated.map((item, index) => ({
//       ...item,
//       order: index + 1,
//     }));

//     console.log("Reordered Items: ", reordered);
//     // setItems(reordered);

//     // Persist to DB
//     // await axios.put("http://localhost:5000/api/items/reorder", { items: reordered });
//   };

//   return (
//     <Admin>
//       <DeleteSchoolModal
//         open={open}
//         onClose={() => {
//           setOpen(false);
//         }}
//         school={deleteSchool}
//         handleDelete={handleDelete}
//         deleteSchoolId={deleteSchoolId}
//       />
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "flex-end",
//           width: "100%",
//           mb: 1,
//         }}
//       >
//         <Button
//           component="span"
//           s
//           variant="contained"
//           sx={{
//             alignSelf: "center",
//             mt: 1,
//             width: "fit-content",
//             backgroundColor: "#177D84",
//             "&:hover": { backgroundColor: "#177D84" },
//           }}
//           onClick={() => {
//             navigate("/admin/addHigherOfficial");
//           }}
//         >
//           Add
//         </Button>
//       </Box>

//       <TableContainer component={Paper}>
//       <DragDropContext onDragEnd={handleDragEnd}>
//         <Droppable droppableId="table">
//           {(provided) => (
//         <Table
//         {...provided.droppableProps}
//               ref={provided.innerRef}
//               >
//           <TableHead>
//             <TableRow>
//               <TableCell>Sno</TableCell>
//               <TableCell>Name</TableCell>
//               <TableCell>Role</TableCell>
//               <TableCell></TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {higherOfficialData?.length != 0 &&
//               higherOfficialData?.map((team, index) => (
//                 <Draggable
//                     key={team._id}
//                     draggableId={team._id}
//                     index={index}
//                   >
//                     {(provided, snapshot) => (
//                 <TableRow key={team._id} ref={provided.innerRef}
//                         {...provided.draggableProps}
//                         {...provided.dragHandleProps}>
//                   <TableCell>{index + 1}</TableCell>
//                   <TableCell>{team.en.name}</TableCell>
//                   <TableCell>{team.en.role}</TableCell>
//                   <TableCell>
//                     <IconButton
//                       aria-label="delete"
//                       onClick={() => handleDeleteSchool(team.en.name, team._id)}
//                     >
//                       <DeleteIcon />
//                     </IconButton>
//                   </TableCell>
//                   <TableCell>
//                     <IconButton aria-label="edit">
//                       <EditIcon
//                         onClick={() => {
//                           navigate(`/admin/EditHigherOfficial/${team._id}`);
//                         }}
//                       />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//                 )}
//                   </Draggable>
//               ))}
//               {provided.placeholder}
//           </TableBody>
//         </Table>
//         )}
//         </Droppable>
//       </DragDropContext>
//       </TableContainer>
//     </Admin>
//   );
// };

// export default HigherOfficial;


// src/pages/HigherOfficial.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Admin from "../Dashboard";
import DeleteSchoolModal from "../School/DeleteSchoolModal";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const HigherOfficial = () => {
  const navigate = useNavigate();
  const [higherOfficialData, setHigherOfficialData] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteSchool, setDeleteSchool] = useState("");
  const [deleteSchoolId, setDeleteSchoolId] = useState("");

  const BASE = process.env.REACT_APP_BASE_URL;

  const getHeaderOfficialDetails = async () => {
    try {
      const response = await axios.get(`${BASE}/getHeaderDetails`, {
        headers: { Authorization: localStorage.getItem("admin_token") },
      });
      if (response.status === 200) {
        // Sort by order if available, otherwise keep original order
        const data = Array.isArray(response.data) ? response.data : [];
        data.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
        setHigherOfficialData(data);
      }
    } catch (err) {
      console.error("Failed to fetch header details", err);
      // handle auth redirect if required
      if (err?.response?.status === 403) {
        localStorage.clear();
        navigate("/admin/login");
      }
    }
  };

  useEffect(() => {
    getHeaderOfficialDetails();
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE}/deleteHeaderOfficialById/${id}`,
        {
          headers: {
            Authorization: localStorage.getItem("admin_token"),
          },
        }
      );
      if (response.status === 200) {
        getHeaderOfficialDetails();
      }
    } catch (error) {
      console.error("Delete error", error);
      if (error?.response?.status === 403) {
        localStorage.clear();
        navigate("/admin/login");
      }
    }
  };

  const handleDeleteSchool = (school, schoolId) => {
    setDeleteSchool(school);
    setDeleteSchoolId(schoolId);
    setOpen(true);
  };

  // Handle drag end
  const handleDragEnd = async (result) => {
    if (!result.destination) return; // dropped outside

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;

    // If dropped in the same position, do nothing
    if (sourceIndex === destinationIndex) return;

    // Copy current list
    const updated = Array.from(higherOfficialData);

    // Remove moved item and insert at new index
    const [moved] = updated.splice(sourceIndex, 1);
    updated.splice(destinationIndex, 0, moved);

    // Recalculate order values (1-based)
    const reordered = updated.map((item, idx) => ({
      ...item,
      order: idx + 1,
    }));

    // Optimistically update UI
    setHigherOfficialData(reordered);

    // Prepare payload (only necessary fields)
    const payload = reordered.map((it) => ({ _id: it._id, order: it.order }));

    try {
      await axios.post(
        `${BASE}/reorderHeaderDetails`, 
        { items: payload }, 
        {
          headers: {
            Authorization: localStorage.getItem("admin_token"),
          },
        }
      );
    } catch (err) {
      console.error("Failed to save new order", err);
      // If persist fails, revert by refetching
      getHeaderOfficialDetails();
    }
  };

  return (
    <Admin>
      <DeleteSchoolModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        school={deleteSchool}
        handleDelete={handleDelete}
        deleteSchoolId={deleteSchoolId}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", mb: 1 }}>
        <Button
          variant="contained"
          sx={{
            alignSelf: "center",
            mt: 1,
            width: "fit-content",
            backgroundColor: "#177D84",
            "&:hover": { backgroundColor: "#177D84" },
          }}
          onClick={() => navigate("/admin/addHigherOfficial")}
        >
          Add
        </Button>
      </Box>

      <DragDropContext onDragEnd={handleDragEnd}>
        <TableContainer component={Paper}>
          <Table aria-label="Higher Officials Table" sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell width="5%">Sno</TableCell>
                <TableCell width="10%">Drag</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Role</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <Droppable droppableId="higherOfficialsDroppable">
              {(provided) => (
                <TableBody
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {higherOfficialData?.length > 0 &&
                    higherOfficialData.map((team, index) => (
                      <Draggable
                        key={team._id}
                        draggableId={String(team._id)}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <TableRow
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            sx={{
                              background: snapshot.isDragging 
                                ? "rgba(25, 118, 210, 0.08)" 
                                : "inherit",
                              '&:hover': {
                                backgroundColor: snapshot.isDragging 
                                  ? "rgba(25, 118, 210, 0.12)" 
                                  : "rgba(0, 0, 0, 0.04)",
                              },
                              transition: 'background-color 0.2s ease',
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              <div {...provided.dragHandleProps} 
                                style={{ 
                                  cursor: 'grab',
                                  display: 'inline-block',
                                  padding: '4px'
                                }}
                              >
                                ⋮⋮
                              </div>
                            </TableCell>
                            <TableCell>{team?.en?.name}</TableCell>
                            <TableCell>{team?.en?.role}</TableCell>
                            <TableCell align="right">
                              <IconButton
                                aria-label="delete"
                                onClick={() => handleDeleteSchool(team?.en?.name, team._id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                              <IconButton
                                aria-label="edit"
                                onClick={() => navigate(`/admin/EditHigherOfficial/${team._id}`)}
                              >
                                <EditIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </TableBody>
              )}
            </Droppable>
          </Table>
        </TableContainer>
      </DragDropContext>
    </Admin>
  );
};

export default HigherOfficial;